import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { Spin } from "antd";

const Callback = () => {
  const history = useHistory();
  const { userManager, loadUser } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        await userManager.signinRedirectCallback();
        await loadUser();
        history.replace("/");
      } catch (error) {
        console.error("Authentication error:", error);
        history.replace("/login");
      }
    };
    handleCallback();
  }, [history, loadUser, userManager]);

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <Spin size="medium"></Spin>
    </div>
  );
};

export default Callback;
